import { render, staticRenderFns } from "./NewCollection.vue?vue&type=template&id=00a3e816&scoped=true&"
import script from "./NewCollection.vue?vue&type=script&lang=js&"
export * from "./NewCollection.vue?vue&type=script&lang=js&"
import style0 from "./NewCollection.vue?vue&type=style&index=0&id=00a3e816&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a3e816",
  null
  
)

export default component.exports